import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import pure from 'recompose/pure';

function TextField({ source, record = {}, elStyle, choices }) {
    let value = get(record, source);
    if (choices) {
        const valid_choice = choices.find((choice) => (choice.id === value));
        if (valid_choice) {
            value = valid_choice.name;
        }
    }

    return (
        <span style={elStyle}>{value}</span>
    );
}

TextField.propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const PureTextField = pure(TextField);

PureTextField.defaultProps = {
    addLabel: true,
};

export default PureTextField;



// WEBPACK FOOTER //
// ./src/components/field/TextField.js